import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles(theme => ({
    container: {

        [theme.breakpoints.down("sm")]: {

        },
    },

}))



export default function ProjectView(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

    const { beforeAfters, altBeforeAfters, images, altImages } = props;
    const [dialogChk, setDialogChk] = React.useState(0);

    return (
        <React.Fragment >
            <div className={classes.container} >
                <Grid container direction="row" spacing={2}>
                    {/*<Grid item sm={6} style={{ cursor: "pointer" }}>*/}
                    {/*    <Grid container direction="row" spacing={1}>*/}
                    {/*        {*/}
                    {/*            beforeAfters.map((image, index) => (*/}
                    {/*                <Grid key={"ba" + index} item xs={12} style={{ height: "100%" }}>*/}
                    {/*                    <ImgComparisonSlider style={{ width: "100%" }}>*/}
                    {/*                        <img alt={altBeforeAfters[index * 2]} slot="before" width="100%" src={image[0]} />*/}
                    {/*                        <img alt={altBeforeAfters[index * 2 + 1]} slot="after" width="100%" src={image[1]} />*/}
                    {/*                    </ImgComparisonSlider>*/}
                    {/*                </Grid>*/}
                    {/*            ))*/}
                    {/*        }*/}
                    {/*    </Grid>*/}
                    {/*</Grid>*/}

                    <Grid item xs={12} style={{ cursor: "pointer" }}>
                        <Grid container direction="row" spacing={1}>
                            {
                                images.map((image, index) => (
                                    <React.Fragment key={"i" + index}>
                                        <Grid item xs={12} sm={6} md={4} lg={3} onClick={() => { setDialogChk(index + 1) }}>
                                            <img alt={altImages[index]} width="100%" src={image}
                                                style={{ objectFit: "cover", width: "100%", height: matchesSM ? "100px" : (matchesMD ? "150px" : "200px"), maxWidth: "100%" }}
                                            />
                                        </Grid>

                                        <Dialog fullWidth={true} maxWidth="sm" open={dialogChk === index + 1} onClose={() => setDialogChk(0)} style={{ userSelect: "none" }} >
                                            <img src={image} alt={altImages[index]} style={{ width: "100%", height: "100%" }} />
                                        </Dialog>

                                    </React.Fragment>
                                ))
                            }

                        </Grid>
                    </Grid>
                </Grid>

            </div>
        </React.Fragment>

    );
}